<template>
  <div class="search-section">
    <div class="container">
      <div class="row align-items-center">
        <div
          class="col-3 d-none d-lg-block categories-wrapper"
          @mouseenter="showCategories = true"
          @mouseleave="showCategories = false"
        >
          <button class="categories-toggle">
            <font-awesome-icon icon="fas fa-th-large" />
            Browse Categories
            <font-awesome-icon icon="fas fa-chevron-down" class="ms-1 chevron-icon" />
          </button>

          <ul v-if="showCategories" class="categories-dropdown">
            <li v-for="(category, index) in categories" :key="`category-${index}`">
              <a :href="'/search/?c=' + category.slug">
                <i :class="category.icon" class="category-icon"></i>
                {{ category.name }}
              </a>
            </li>
          </ul>
        </div>

        <div class="col d-none d-lg-block">
          <ul class="nav-links">
            <li>
              <router-link to="/">Home</router-link>
            </li>
            <li
              class="brand-menu-wrapper"
              @mouseenter="showBrands = true"
              @mouseleave="showBrands = false"
            >
              <a href="#" class="brand-toggle" @click.prevent>
                Brand
                <font-awesome-icon
                  icon="fas fa-chevron-down"
                  class="ms-1 chevron-icon"
                />
              </a>

              <div v-if="showBrands" class="brands-mega-dropdown">
                <div
                  v-for="(group, gi) in brandGroups"
                  :key="`brand-group-${gi}`"
                  class="brand-group"
                >
                  <h6 class="brand-group-title">{{ group.title }}</h6>
                  <ul
                    class="brand-list"
                    :style="{ columnCount: group.columns }"
                  >
                    <li
                      v-for="(brand, bi) in group.brands"
                      :key="`brand-${gi}-${bi}`"
                    >
                      <a :href="'/brand/' + brand.replace(/ /g, '_')">
                        {{ brand }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li>
              <router-link to="/search">Shop</router-link>
            </li>
            <li>
              <router-link to="/compare">
                Compare
                <span
                  v-if="compareItemCount"
                  class="badge bg-danger ms-2"
                >
                  {{ compareItemCount }}
                </span>
              </router-link>
            </li>
            <!-- <li>
              <router-link to="/blogs">Blogs</router-link>
            </li> -->
            <li>
              <router-link :to="{ path: '/contact' }">Contact</router-link>
            </li>
          </ul>
        </div>

        <div class="col-auto d-none d-lg-flex icon-group">
          <router-link class="icon-link" to="/wishlist">
            <i class="bi bi-heart"></i>
            <span
              v-if="wishlistItemCount"
              class="badge-count position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center badge bg-danger"
            >
              {{ wishlistItemCount }}
            </span>
          </router-link>
          <router-link class="icon-link" to="/cart">
            <i class="bi bi-cart"></i>
            <span
              v-if="cartItemCount"
              class="badge-count position-absolute top-0 start-100 translate-middle d-flex align-items-center justify-content-center badge bg-danger"
            >
              {{ cartItemCount }}
            </span>
          </router-link>
          <router-link class="icon-link" to="/profile">
            <i class="bi bi-person"></i>
          </router-link>
        </div>
      </div>
    </div>

    <!--
      Request a Product Modal — not part of the current visual design, but kept
      here (commented out) so it can be re-enabled later. Re-add a trigger
      (e.g. a button/link in the row above) and set `showRequestModal = true`
      to reuse it.
    -->
    <!--
    <div
      v-if="showRequestModal"
      class="modal fade show d-block"
      tabindex="-1"
      style="background-color: rgba(0, 0, 0, 0.5)"
    >
      <div class="modal-dialog">
        <div v-if="!isLoggedIn" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Please login first.</h5>
            <button
              type="button"
              class="btn-close"
              @click="showRequestModal = false"
            ></button>
          </div>
          <div class="modal-footer">
            <button class="btn btn-primary" @click="goToLogin">
              Login
            </button>
          </div>
        </div>
        <div v-else class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Request a Product</h5>
            <button
              type="button"
              class="btn-close"
              @click="showRequestModal = false"
            ></button>
          </div>
          <div class="modal-body">
            <textarea
              v-model="requestedProduct"
              v-if="!requestSuccess"
              class="form-control"
              placeholder="Product name, brand etc."
            ></textarea>
            <div v-if="requestSuccess" class="d-block p-5 text-center">
              <h5>Your request is successfully placed.</h5>
            </div>
          </div>
          <div v-if="!requestSuccess" class="modal-footer">
            <button class="btn btn-secondary" @click="showRequestModal = false">
              Cancel
            </button>
            <button class="btn btn-primary" @click="requestProduct">
              Send Request
            </button>
          </div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>
// import axios from "axios";
// import { BASE_URL } from "@/globals";

export default {
  name: "SearchSection",
  data() {
    return {
      showCategories: false,
      showBrands: false,
      brandGroups: [
        {
          title: "Korean Brand",
          columns: 5,
          brands: [
            "Abib",
            "Anua",
            "APLB",
            "April Skin",
            "Arencia",
            "Aromatica",
            "AXIS-Y",
            "Banila Co.",
            "Beauty of Joseon",
            "BRINGGREEN",
            "Celimax",
            "Cos De BAHA",
            "COSRX",
            "Dr. Althea",
            "Dr. Ceuracle",
            "Eqqualberry",
            "Etude House",
            "FINO",
            "FULLY",
            "Goodal",
            "HaruHaru Wonder",
            "Heimish",
            "Heveblue",
            "House of Hur",
            "Illiyoon",
            "I'M FROM",
            "Innisfree",
            "Isntree",
            "Jumiso",
            "KAINE",
            "KSECRET",
            "Laneige",
            "lunik",
            "Manyo",
            "Mary & May",
            "Medicube",
            "Missha",
            "Mixsoon",
            "Nature Republic",
            "Neogen Dermalogy",
            "Nineless",
            "Numbuzin",
            "Purito",
            "Pyunkang Yul",
            "Round Lab",
            "Rovectin",
            "Some By Mi",
            "The Face Sop",
            "Tiam",
            "TIRTIR",
            "Tocobo",
            "Torriden",
            "VT Cosmetics",
          ],
        },
        {
          title: "USA/UK/France/Brand",
          columns: 1,
          brands: [
            "Bath & Body Works",
            "Bioderma",
            "Cerave",
            "Cetaphil",
            "Differin",
            "La Roche Posay",
            "Mielle",
            "Neutrogena",
            "PanOxyl",
            "Paula's Choice",
            "The Ordinary",
          ],
        },
      ],
      categories: [
        {
          name: "Cleansers",
          icon: "bi bi-droplet",
          slug: "cleansers",
        },
        {
          name: "Face Serums",
          icon: "bi bi-eyedropper",
          slug: "face_serums",
        },
        {
          name: "Moisturizer",
          icon: "bi bi-moisture",
          slug: "moisturizer",
        },
        {
          name: "Sunscreen",
          icon: "bi bi-sun",
          slug: "sunscreen",
        },
        {
          name: "Toners",
          icon: "bi bi-water",
          slug: "toners",
        },
        {
          name: "Face Masks",
          icon: "bi bi-stars",
          slug: "face_masks",
        },
        {
          name: "Acne Care",
          icon: "bi bi-shield-check",
          slug: "acne_care",
        },
        {
          name: "Anti-Aging",
          icon: "bi bi-hourglass-split",
          slug: "anti_aging",
        },
        {
          name: "Body Care",
          icon: "bi bi-heart",
          slug: "body_care",
        },
        {
          name: "Lip Care",
          icon: "bi bi-emoji-kiss",
          slug: "lip_care",
        },
      ]

      // --- Request a Product feature: hidden in the current design, kept for later ---
      // showRequestModal: false,
      // requestedProduct: null,
      // errorMessage: null,
      // requestSuccess: false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    cartItemCount() {
      return this.$store.getters.cartItemCount;
    },
    wishlistItemCount() {
      return this.$store.getters.wishlistItemCount;
    },
    compareItemCount() {
      return this.$store.getters.compareItemCount;
    },
  },
  methods: {},
};
</script>

<style lang='scss' scoped>
/* ################# */
/* Search Section -> now the secondary nav row */

.search-section {
  background-color: #fff;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  padding: 14px 0;
  position: relative;
}

.categories-wrapper {
  position: relative;
}

.categories-toggle {
  color: #333;
  background: transparent;
  border: none;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  width: 100%;

  .chevron-icon {
    font-size: 12px;
    opacity: 0.6;
  }

  &:hover {
    color: var(--primary-color);
  }
}

.categories-dropdown {
  position: absolute;
  top: 100%;
  left: 15px;
  width: 280px;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  list-style: none;
  padding: 8px 0;
  z-index: 20;

  li a {
    display: flex;
    align-items: center;
    padding: 10px 18px;
    color: #333;
    text-decoration: none;
    font-size: 14px;

    .category-icon {
      margin-right: 10px;
      opacity: 0.6;
      width: 16px;
    }

    &:hover {
      background-color: #f8f9fa;
      color: var(--primary-color);

      .category-icon {
        opacity: 1;
      }
    }
  }
}

.nav-links {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  margin: 0;
  padding: 0;

  li a {
    color: #333;
    text-decoration: none;
    font-weight: 500;
    font-size: 16px;
  }

  li a:hover,
  li a.router-link-active {
    color: var(--primary-color);
  }
}

/* Brand mega dropdown */
.brand-menu-wrapper {
  position: relative;

  .brand-toggle {
    display: inline-flex;
    align-items: center;
    cursor: pointer;

    .chevron-icon {
      font-size: 12px;
      opacity: 0.6;
    }
  }

  &:hover .brand-toggle {
    color: var(--primary-color);
  }
}

.brands-mega-dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 1140px;
  max-width: 95vw;
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
  padding: 26px 30px;
  z-index: 30;
  display: flex;
  gap: 36px;

  .brand-group {
    &:first-child {
      flex: 1 1 auto;
    }
    &:last-child {
      flex: 0 0 auto;
    }
  }

  .brand-group-title {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #222;
    margin-bottom: 16px;
  }

  .brand-list {
    list-style: none;
    margin: 0;
    padding: 0;
    column-gap: 24px;

    li {
      margin-bottom: 10px;
      break-inside: avoid;
    }

    li a {
      display: inline-block;
      color: #555;
      text-decoration: none;
      font-size: 13px;
      font-weight: 400;

      &:hover {
        color: var(--primary-color);
      }
    }
  }
}

.icon-group {
  display: flex;
  align-items: center;
  gap: 22px;

  .icon-link {
    position: relative;
    color: #333;
    font-size: 19px;
    text-decoration: none;
    align-items: center;
    line-height: 0;

    &:hover {
      color: var(--primary-color);
    }
  }

  .badge-count {
    width: 16px;
    height: 16px;
    border-radius: 50%;
    font-size: 10px;
  }
}

@media (max-width: 991px) {
  .search-section {
    display: none;
  }
}
</style>